import script from "./BaseExpand.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseExpand.vue?vue&type=script&setup=true&lang=js"

import "./BaseExpand.vue?vue&type=style&index=0&id=3971797a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3971797a"]])

export default __exports__